import $ from 'jquery';

const filtersRows = $('.resources-filter__rows'),
  filtersFormTitle  = $('.resources-filter-title');

let resizeFlag;

function checkMobile() {
  if ($(window).width() >= 992) {
    resizeFlag = false;
    filtersRows.slideDown();
  } else {
    resizeFlag = true;
    filtersFormTitle.removeClass('opened');
    filtersRows.slideUp();
  }
}

function toggleMenuControl() {
  if (resizeFlag) {
    if (filtersRows.is(':visible')) {
      $(this).removeClass('opened');
      filtersRows.slideUp();
    } else {
      $(this).addClass('opened');
      filtersRows.slideDown();
    }
  } else {
    return false;
  }
}

filtersFormTitle.on('click', toggleMenuControl);

checkMobile();

$(window).on('resize', function () {
  checkMobile();
});
